import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiLock, FiUser } from "react-icons/fi";

function Login() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [error, setError] = useState("");

  const handleLogin = () => {
    if (usuario === "1" && contrasena === "1") {
      setError("");
      sessionStorage.setItem("usuario", usuario);
      sessionStorage.setItem("rol", "soloInicio");
      navigate("/home", { state: { role: "soloInicio" } });
    } else if (usuario === "2" && contrasena === "2") {
      setError("");
      sessionStorage.setItem("usuario", usuario);
      sessionStorage.setItem("rol", "todo");
      navigate("/home", { state: { role: "todo" } });
    } else {
      setError("❌ Usuario o contraseña incorrectos");
    }
  };

  return (
    <div
      className="min-h-screen text-gray-800 font-sans relative overflow-x-hidden flex items-center justify-center"
      style={{
        background: "linear-gradient(135deg, #e8ffef 0%, #c3f8ff 100%)"
      }}
    >
      {/* Onda decorativa SVG en la parte inferior */}
      <div className="absolute bottom-0 left-0 w-full pointer-events-none select-none z-0" style={{ lineHeight: 0 }}>
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path fill="#86e2d5" fillOpacity="0.45" d="M0,60 C360,120 1080,0 1440,60 L1440,120 L0,120 Z"></path>
          <path fill="#a8e063" fillOpacity="0.27" d="M0,90 C400,60 1040,140 1440,90 L1440,120 L0,120 Z"></path>
          <path fill="#56c5e1" fillOpacity="0.15" d="M0,110 C480,80 960,160 1440,110 L1440,120 L0,120 Z"></path>
        </svg>
      </div>
      <div className="relative z-10 w-full max-w-xs sm:max-w-sm">
        <div className="bg-white/90 backdrop-blur-sm p-8 rounded-2xl shadow-xl border border-[#dbeafe]">
          <h1 className="text-4xl font-extrabold mb-8 text-center text-[#2377b1] tracking-widest drop-shadow flex items-center justify-center gap-2">
            <span className="text-5xl">💧</span>
            Dimalink
          </h1>
          <div className="mb-5">
            <label className="block text-gray-700 mb-1 font-semibold">Usuario</label>
            <div className="flex items-center border border-blue-200 rounded px-3 py-2 bg-white/70">
              <FiUser className="text-blue-300 mr-2 text-lg" />
              <input
                type="text"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                placeholder="Ingresa usuario"
                className="flex-1 focus:outline-none text-sm bg-transparent"
              />
            </div>
          </div>
          <div className="mb-5">
            <label className="block text-gray-700 mb-1 font-semibold">Contraseña</label>
            <div className="flex items-center border border-blue-200 rounded px-3 py-2 bg-white/70">
              <FiLock className="text-blue-300 mr-2 text-lg" />
              <input
                type="password"
                value={contrasena}
                onChange={(e) => setContrasena(e.target.value)}
                placeholder="••••••••"
                className="flex-1 focus:outline-none text-sm bg-transparent"
              />
            </div>
          </div>
          {error && (
            <div className="bg-red-100 text-red-700 text-sm rounded p-2 mb-4 border border-red-200">
              {error}
            </div>
          )}
          <button
            onClick={handleLogin}
            className="w-full bg-gradient-to-r from-blue-400 to-cyan-400 text-white py-2 rounded-full font-bold shadow hover:from-blue-500 hover:to-cyan-500 hover:shadow-lg transition"
          >
            Ingresar
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;